/** Sparkline del sistema: base + línea, con leyenda. Puntos ya en 0–56/0–300. */
export function Spark({ points, cap }: { points: string; cap?: React.ReactNode | undefined }) {
  return (
    <div className="sk-spark">
      <svg viewBox="0 0 300 56" preserveAspectRatio="none" aria-hidden="true">
        <polyline className="sk-spark-base" points="0,50 300,50" />
        <polyline className="sk-spark-line" points={points} />
      </svg>
      {cap !== undefined && <div className="sk-spark-cap">{cap}</div>}
    </div>
  );
}
/** Barra horizontal con clave y valor (top implantaciones). */
export function BarRow({ k, width, v }: { k: React.ReactNode; width: string; v: React.ReactNode }) {
  return <div className="sk-barrow"><span className="sk-barrow-k">{k}</span><span className="sk-bar" style={{ width }} /><span className="sk-barrow-v">{v}</span></div>;
}
